export default {"src":"/_next/static/media/baby_64.43a2de37.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};